<template>
  <div class="cart-header">
    <button class="btn " @click="close">
      <span class="ti-arrow-left"> {{'back' | setText('Назад')}}</span>
    </button>
  </div>
</template>
<script>
export default {
  name: "header",
  props: ["card"],
  methods: {
    close() {
      let query = Object.assign({}, this.$route.query);
      if (query[this.card]) {
        delete query[this.card];
      } else {
        return false;
      }
      this.$router.replace({ query });
    },
  },
  components: {},
};
</script>
<style>
</style>
